import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export const SUBLEVELS_COUNT = 6 as const;
export const LEVELS_COUNT = 27 as const;

export function readBuildingFloorLabel(value: string) {
  return getDefaultBuildingFloorOptions().find(option => option.value === value)?.label ?? value;
}

export function readBuildingFloorValue(value: string) {
  return getDefaultBuildingFloorOptions().find(option => option.value === value || option.label === value)?.value ?? '';
}

export function getDefaultBuildingFloorOptions() {
  return getBuildingFloorOptions();
}

export function getBuildingFloorOptions() {
  return [
    ...Array.from({ length: SUBLEVELS_COUNT }, (_, floorIndex) => {
      const value = -SUBLEVELS_COUNT + floorIndex;
      return { label: translateBuildingFloor(value), value: value.toString() };
    }),
    ...Array.from({ length: LEVELS_COUNT }, (_, floorIndex) => ({
      label: translateBuildingFloor(floorIndex),
      value: floorIndex.toString(),
    })),
  ];
}

export function translateBuildingFloor(level: number | null) {
  if (level === null) {
    return '';
  }

  if (level < 0) {
    return translateInventoryText('app.common.buildingFloor.undergroundFloor', '{level}. underground floor', {
      level: Math.abs(level),
    });
  }

  if (level > 0) {
    return translateInventoryText('app.common.buildingFloor.floor', '{level}. floor', { level });
  }

  return translateInventoryText('app.common.buildingFloor.groundFloor', 'Ground floor');
}
